import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Radio from '../Radio';
import s from './RadioGroup.scss';

const RadioGroup = ({ legend, name, fluid, radioProps, required }) => (
  <fieldset className={cx(s.root, fluid && s.fluid)} aria-label="RadioGroup">
    {legend && <legend>{legend}</legend>}
    {radioProps && (
      <div className={s.wrapper}>
        {radioProps.map(
          ({
            value,
            label,
            hint,
            isSelected,
            disabled,
            onChange,
            icon,
            iconSize,
            link,
            image,
            blockBtn,
          }) => (
            <Radio
              name={name}
              key={value.toString()}
              disabled={disabled}
              label={label}
              hint={hint}
              value={value.toString()}
              isSelected={isSelected}
              onChange={({ target }) => onChange(name, target.value)}
              className={s.radio}
              required={required}
              icon={icon}
              iconSize={iconSize}
              link={link}
              image={image}
              blockBtn={blockBtn}
            />
          ),
        )}
      </div>
    )}
  </fieldset>
);

RadioGroup.propTypes = {
  legend: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool]),
  name: PropTypes.string.isRequired,
  fluid: PropTypes.bool,
  radioProps: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  required: PropTypes.bool,
};

RadioGroup.defaultProps = {
  fluid: false,
  required: false,
  legend: false,
};

export default withStyles(s)(RadioGroup);
